import { ExternalRedirectRoute } from '../Routing/types';
const redirects: ExternalRedirectRoute[] = [
  {
    path: '/contact',
    externalRedirectTo: {
      'pl-PL': 'https://mamhashi.zendesk.com/hc/pl',
    },
  },
];

export default redirects;
